(() => {
  const commerceSelector = selector => selector.split(',').map(part => {
    const value = part.trim();
    return /^\[data-(total|ship|summary|lines|checkout|cart-fallback|cart-error|cart-key|cart-remove|preview-remove)\]$/.test(value) ? '[data-sheet="cart"] ' + value : value;
  }).join(',');
  const mainColorSlots = (slots, selected) => slots.length === 1 ? [selected] : slots;
  const combinedBenefit = (savings, formatMoney) => `${savings > 0 ? `Save ${formatMoney(savings)} on ready sets · ` : ''}Pay shipping only once`;
  const groupSelection = (slots, variants) => {
    const groups = new Map();
    for (const index of slots) {
      const variant = variants[index];
      if (!variant) throw new Error('Invalid variant selection');
      const previous = groups.get(variant.id);
      if (previous) previous.quantity += 1;
      else groups.set(variant.id, { variant, id: variant.id, quantity: 1 });
    }
    return Array.from(groups.values());
  };
  const isBackorder = (variant) => Boolean(variant.tracked && variant.stock <= 0 && variant.policy === 'continue' && variant.available);
  const canOrder = (groups) => groups.length > 0 && groups.every(({ variant, quantity }) => variant.available && quantity > 0 && Number.isInteger(quantity) && quantity <= (variant.max || 99) && (!variant.tracked || variant.policy !== 'deny' || quantity <= Math.max(0, variant.stock)));
  const previewTier = (count) => {
    const index = count >= 5 ? 2 : count >= 3 ? 1 : 0;
    return { now: [0, 8, 10][index], back: [10, 18, 20][index] };
  };
  const previewVariantSource = (source, extras = []) => {
    const merged = [...source];
    const name = (variant) => variant.title.trim().toLowerCase();
    for (const variant of extras) {
      if (!merged.some((existing) => String(existing.id) === String(variant.id) || name(existing) === name(variant))) merged.push(variant);
    }
    const order = ['red', 'green', 'blue', 'black', 'white', 'pink', 'yellow', 'purple'];
    const rank = (variant) => { const index = order.indexOf(name(variant)); return index < 0 ? order.length : index; };
    return merged.sort((first, second) => rank(first) - rank(second));
  };
  const previewVariants = (source, snapshot = []) => source.map((variant) => {
    const item = snapshot.find((entry) => String(entry.id) === String(variant.id));
    const known = item && Number.isSafeInteger(item.available) && item.available >= 0;
    const stock = known ? item.available : 0;
    const previewBack = known && item.backorderEligible === true ? 99 : 0;
    return { ...variant, stock, previewBack, tracked: true, available: Boolean(known && (stock > 0 || previewBack > 0)), policy: previewBack ? 'continue' : 'deny', max: 99 };
  });
  const previewTotals = (slots, variants, shipping = 0) => {
    const tier = previewTier(slots.length);
    const used = new Map();
    const ships = slots.map((index) => {
      const variant = variants[index];
      if (!variant) return -1;
      const count = (used.get(variant.id) || 0) + 1;
      used.set(variant.id, count);
      return !variant.available ? -1 : count <= Math.max(0, variant.stock) ? 0 : count <= Math.max(0, variant.stock) + (variant.previewBack || 0) ? 1 : -1;
    });
    const pools = [...new Set(ships.filter((pool) => pool >= 0))];
    const mixed = pools.length > 1;
    const unit = (index, back) => Math.round(variants[index].price * (100 - (back ? tier.back : tier.now)) / 100);
    const asapMerch = slots.reduce((sum, index, position) => sum + (ships[position] < 0 ? 0 : unit(index, ships[position] === 1)), 0);
    const togetherMerch = mixed ? slots.reduce((sum, index, position) => sum + (ships[position] < 0 ? 0 : unit(index, true)), 0) : asapMerch;
    const plan = (merch, boxes) => ({ merch, boxes, shipping: shipping * boxes, total: merch + shipping * boxes });
    return { tier, ships, mixed, valid: slots.length > 0 && slots.length <= 99 && ships.every((pool) => pool >= 0), asap: plan(asapMerch, pools.length), together: plan(togetherMerch, pools.length ? 1 : 0) };
  };
  const defaultPackSlots = (count, variants, preferred = 0) => {
    const ready = variants.map((variant, index) => ({ variant, index })).filter(({ variant }) => variant.available && variant.stock > 0).map(({ index }) => index);
    const start = ready.indexOf(preferred);
    if (start > 0) ready.unshift(...ready.splice(start, 1));
    return ready.length ? Array.from({ length: count }, (_, index) => ready[index % ready.length]) : [];
  };
  const previewGroupDispatch = (id, slots, variants, allocation) => slots.reduce((counts, index, position) => {
    if (String(variants[index].id) === String(id)) {
      if (allocation.ships[position] === 0) counts.ready++;
      else if (allocation.ships[position] === 1) counts.backorder++;
    }
    return counts;
  }, { ready: 0, backorder: 0 });
  window.PolygonsPurchaseModel = { combinedBenefit, mainColorSlots, commerceSelector, defaultPackSlots, previewGroupDispatch, groupSelection, isBackorder, canOrder, previewTier, previewVariantSource, previewVariants, previewTotals };
  if (typeof document === 'undefined' || !document) return;
  const dataElement = document.getElementById('PolygonsData');
  if (!dataElement) return;
  const data = JSON.parse(dataElement.textContent);
  if (window.PolygonsNativeProductPage?.mount(data)) return;
  if (window.PolygonsNativeContext?.hostname === 'polygons-1.myshopify.com') {
    document.querySelectorAll('[data-add],[data-sticky-cta],[data-buy-now],[data-sheet="cart"] [data-checkout]').forEach(button => { button.disabled = true; });
    document.querySelectorAll('[data-preview-offer]').forEach(element => { element.hidden = true; element.inert = true; });
    const error = document.querySelector('[data-purchase-error]');
    if (error) { error.textContent = window.PolygonsNativeStrings?.unavailable || 'This purchase option is temporarily unavailable.'; error.hidden = false; }
    document.getElementById('PolygonsProductForm')?.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); }, true);
    return;
  }
  const $ = (selector, parent = document) => parent.querySelector(parent === document ? commerceSelector(selector) : selector);
  const $$ = (selector, parent = document) => Array.from(parent.querySelectorAll(parent === document ? commerceSelector(selector) : selector));
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const text = (key, values = {}) => (data.i18n[key] || key).replace(/__(\w+)__/g, (_, token) => String(values[token] ?? ''));
  const icon = (name) => `<svg class="icon icon--sm" aria-hidden="true"><use href="#i-${name}"/></svg>`;
  const designPreview = data.designPreview === true;
  const testProduct = data.testProduct === true && String(data.productId) === '15410424742039';
  const allocationModel = window.PolygonsAllocation;
  const testText = (key, values = {}) => (data.testI18n?.[key] || key).replace(/__(\w+)__/g, (_, token) => String(values[token] ?? ''));
  if (testProduct && !allocationModel) {
    $$('[data-add],[data-sticky-cta],[data-checkout],[data-buy-now]').forEach((button) => { button.disabled = true; });
    const error = $('[data-purchase-error]');
    error.textContent = testText('refresh_failed');
    error.hidden = false;
    $('#PolygonsProductForm').addEventListener('submit', (event) => event.preventDefault());
    return;
  }
  let currency = designPreview ? 'USD' : data.currency || 'USD';
  const money = (cents) => new Intl.NumberFormat(data.locale || 'en', { style: 'currency', currency }).format(cents / 100);
  const root = data.root.endsWith('/') ? data.root : data.root + '/';
  const variants = designPreview ? previewVariants(previewVariantSource(data.variants, data.previewVariants || []), data.previewInventory?.variants) : data.variants;
  const initial = Math.max(0, variants.findIndex((variant) => String(variant.id) === String(data.selectedId)));
  let slots = [initial];
  let active = 0;
  let previewColor = null;
  let shipPreference = 'together';
  const restockDate = new Date(`${data.previewInventory?.restockDate || data.restockDate || '2026-11-15'}T12:00:00`);
  const restockLabel = restockDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const shippingEstimate = 0;
  if (designPreview) {
    const params = new URL(location.href).searchParams;
    const colors = (params.get('colors') || '').split(',').map((color) => variants.findIndex((variant) => variant.title.toLowerCase() === color.toLowerCase()));
    if (colors.length <= 99 && colors.every((index) => index >= 0)) { slots = colors; active = slots.length - 1; }
    shipPreference = params.get('ship') === 'asap' ? 'asap' : 'together';
  }
  let busy = false;
  let cart = null;
  let cartRead = null;
  let previewCartSlots = [];
  let previewCartPreference = 'together';
  let previewGift = '';
  const form = $('#PolygonsProductForm');
  const variantInput = $('#PolygonsVariant');
  const quantityInput = $('[data-product-quantity]');
  const giftToggle = { checked: false };
  const giftNote = { value: '' };
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const ui = () => window.PolygonsUI;
  const selection = () => groupSelection(slots, variants);
  const activeVariant = () => variants[slots[active]];
  const plans = () => previewTotals(slots, variants, shippingEstimate);
  const liveAllocation = () => allocationModel.allocate(slots, variants, cart?.items || []);
  const deliveryChoice = () => shipPreference === 'asap' ? 'split' : 'together';
  const total = () => designPreview ? plans()[shipPreference].merch : selection().reduce((sum, item) => sum + item.variant.price * item.quantity, 0);
  const track = $('[data-track]');
  const slideCount = track.children.length;
  let slide = 0;
  let scrollFrame;
  const syncGallery = () => {
    if (!track.clientWidth) return;
    slide = Math.max(0, Math.min(slideCount - 1, Math.round(track.scrollLeft / track.clientWidth)));
    $$('[data-thumb]').forEach((thumb, index) => {
      thumb.setAttribute('aria-selected', String(index === slide));
      thumb.tabIndex = index === slide ? 0 : -1;
    });
    $$('video', track).forEach((video) => { if (Number(video.closest('[data-slide]')?.dataset.slide) !== slide) video.pause(); });
  };
  const goTo = (index) => {
    slide = (index + slideCount) % slideCount;
    track.scrollTo({ left: slide * track.clientWidth, behavior: motion.matches ? 'instant' : 'smooth' });
  };
  track.addEventListener('scroll', () => { cancelAnimationFrame(scrollFrame); scrollFrame = requestAnimationFrame(syncGallery); }, { passive: true });
  $('[data-thumbs]').addEventListener('click', (event) => { const thumb = event.target.closest('[data-thumb]'); if (thumb) goTo(Number(thumb.dataset.thumb)); });
  $('[data-thumbs]').addEventListener('keydown', (event) => {
    if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
    event.preventDefault();
    goTo(slide + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1));
    $$('[data-thumb]')[slide].focus();
  });
  $('[data-prev]').addEventListener('click', () => goTo(slide - 1));
  $('[data-next]').addEventListener('click', () => goTo(slide + 1));
  track.addEventListener('click', (event) => {
    const play = event.target.closest('[data-inline-video]');
    if (!play) return;
    const video = document.createElement('video');
    video.src = play.dataset.inlineVideo;
    video.controls = true;
    video.playsInline = true;
    play.closest('.slide').replaceChildren(video);
    video.play().catch(() => {});
  });
  let imageId = data.selectedId;
  const showImage = (variant) => {
    if (variant.id === imageId) return;
    imageId = variant.id;
    const image = $('.polygons-variant-image');
    image.removeAttribute('srcset');
    image.src = variant.image;
    image.alt = `${data.title}: ${variant.title}`;
    const thumb = $('.polygons-variant-thumb');
    thumb.removeAttribute('srcset');
    thumb.src = variant.thumb;
    $('[data-sticky-img]').src = variant.thumb;
    goTo(0);
  };
  if (designPreview) {
    const colors = { red: '#D93A50', green: '#58C99C', blue: '#5F8FDA', black: '#383838', white: '#EFEFEF', pink: '#F2A7A9', yellow: '#F6CC8C', purple: '#CDB3DF' };
    $('[data-swatches]').innerHTML = variants.map((variant, index) => `<button class="swatch" type="button" role="radio" aria-checked="${index === initial}" aria-label="${escape(variant.title)}" data-color="${index}" data-variant-id="${escape(variant.id)}" style="--c:${colors[variant.title.toLowerCase()] || '#bbbbbb'}"><span class="swatch__flag" aria-hidden="true"></span>${/^(pink|yellow|purple)$/i.test(variant.title) ? '<span class="swatch__new" aria-hidden="true">New</span>' : ''}</button>`).join('');
    variantInput.innerHTML = variants.map((variant, index) => `<option value="${escape(variant.id)}" ${index === initial ? 'selected' : ''}>${escape(variant.title)}</option>`).join('');
  }
  const previewNote = $('[data-preview-inventory-note]');
  if (designPreview && previewNote) previewNote.textContent = 'Team preview · Checkout disabled';
  if (designPreview && data.previewInventory?.asOf) { const details = $('[data-preview-notice] > div'); if (details) details.textContent += ` Inventory snapshot: ${data.previewInventory.asOf}.`; }
  const originalSwatches = $('[data-swatches]').innerHTML;
  $('[data-sticky-swatches]').innerHTML = originalSwatches;
  $('[data-sticky-swatches]').setAttribute('role', 'radiogroup');
  $('[data-sticky-swatches]').setAttribute('aria-label', variantInput.closest('label').firstChild.textContent.trim());
  const setError = (selector, message) => {
    const element = $(selector);
    element.textContent = message || '';
    element.hidden = !message;
  };
  const stateOf = (variant) => !variant.available ? 'waitlist' : isBackorder(variant) ? 'backorder' : variant.tracked && variant.stock <= 50 ? 'low' : 'in-stock';
  const availability = (variant) => {
    const state = stateOf(variant);
    if (state === 'waitlist') return text('soldOut');
    if (state === 'low') return `Only ${Math.max(0, variant.stock)} left`;
    if (state === 'backorder-low') return `${variant.previewBack} left · ships ${restockLabel}`;
    if (state === 'backorder') return designPreview ? `Ships ${restockLabel}` : text('backorder');
    return 'In stock';
  };
  const colorHex = (index) => $(`[data-color="${index}"]`).style.getPropertyValue('--c');
  const renderSlots = (allocation) => {
    const focus = document.activeElement;
    const focusedRow = focus?.dataset?.setColor;
    const focusedAdd = focus?.hasAttribute?.('data-slot-add');
    const add = `<button type="button" class="slot slot--add" data-slot-add ${slots.length >= 99 ? 'disabled' : ''}>${icon('plus')}${escape(text('addSet'))}</button>`;
    const rows = slots.map((index, number) => {
      const item = variants[index];
      const pool = designPreview ? allocation.ships[number] : testProduct ? ({ ready: 0, backorder: 1, unavailable: -1 })[allocation.units[number].pool] : !item.available ? -1 : isBackorder(item) ? 1 : 0;
      const options = variants.map((option, value) => `<option value="${value}" ${value === index ? 'selected' : ''}>${escape(option.title)}: ${escape(availability(option))}</option>`).join('');
      const ship = pool < 0 ? text('soldOut') : pool === 0 ? (designPreview ? 'Ships now' : testProduct ? testText('ready') : 'In stock') : designPreview ? `Ships ${restockLabel}` : text('backorder');
      return `<li class="set-row ${pool < 0 ? 'is-out' : ''}"><span class="set-row__num">${escape(text('set'))} ${number + 1}</span><span class="set-row__pick"><span class="set-row__dot" style="--c:${escape(colorHex(index))}" aria-hidden="true"></span><label class="sr-only" for="polygons-set-color-${number}">${escape(text('setColor', { number: number + 1, color: item.title }))}</label><select id="polygons-set-color-${number}" class="set-row__select set-row__select--swatch" data-set-color="${number}">${options}</select><span class="set-row__status" aria-hidden="true">${escape(ship)}</span></span><button type="button" class="set-row__x" data-slot-remove="${number}" aria-label="${escape(text('removeSet'))} ${number + 1}">${icon('close')}</button></li>`;
    }).join('');
    const singleLabel = testProduct ? testText('mix_scenarios') : 'Want to mix colors?';
    const multiLabel = testProduct ? escape(testText('choose_scenarios', { count: slots.length })) : `Pick a color for each of your ${slots.length} sets`;
    $('[data-slots]').innerHTML = slots.length === 1 ? `<div class="sets sets--single"><p class="sets__label">${escape(singleLabel)}</p>${add}</div>` : `<div class="sets"><p class="sets__label">${multiLabel}</p><ol class="sets__list">${rows}</ol>${add}</div>`;
    if (focusedRow !== undefined) $(`[data-set-color="${Math.min(Number(focusedRow), slots.length - 1)}"]`)?.focus({ preventScroll: true });
    else if (focusedAdd) $('[data-slot-add]')?.focus({ preventScroll: true });
  };
  const renderDelivery = (allocation) => {
    const container = $('[data-delivery]');
    if (testProduct && container) {
      container.hidden = false;
      if (!allocation.valid) { container.innerHTML = `<p class="polygons-error">${escape(testText('invalid_selection'))}</p>`; return; }
      const focus = document.activeElement?.matches?.('[data-ship-pref]') ? document.activeElement.value : null;
      const quote = allocationModel.quote(allocation, deliveryChoice());
      const card = (value, title, sub) => {
        const estimate = allocationModel.quote(allocation, value === 'asap' ? 'split' : 'together');
        const savings = value === 'together' ? allocationModel.quote(allocation, 'split').merch - estimate.merch : 0;
        const benefit = value === 'together' ? `<b>${escape(combinedBenefit(savings, money))}</b>` : 'Shipping charged for each shipment.';
        return `<label class="dopt ${shipPreference === value ? 'is-on' : ''}"><input type="radio" name="polygons-ship-pref" value="${value}" data-ship-pref ${shipPreference === value ? 'checked' : ''}><span class="dopt__main"><strong>${escape(title)}</strong><small>${escape(sub)} ${benefit}</small></span><span class="dopt__money"><strong>${escape(money(estimate.merch))}</strong><small>${escape(testText('merch_estimate'))}</small></span></label>`;
      };
      const choices = allocation.mixed ? `<fieldset class="dopts"><legend class="opt__label">${escape(testText('delivery_preference'))}</legend>${card('asap', testText('split'), testText('split_description'))}${card('together', testText('together'), testText('together_description'))}</fieldset>` : '';
      container.innerHTML = `${choices}<div class="polygons-test-quote" role="note"><strong>${escape(testText('estimate_title'))}</strong><p>${escape(testText('allocation_summary', allocation.counts))}</p><dl><div><dt>${escape(testText('catalog_total'))}</dt><dd>${escape(money(quote.base))}</dd></div><div><dt>${escape(testText('proposed_savings'))}</dt><dd>−${escape(money(quote.savings))}</dd></div><div><dt>${escape(testText('proposed_total'))}</dt><dd>${escape(money(quote.merch))}</dd></div></dl><p>${escape(testText('estimate_note'))}</p></div>`;
      if (focus) $(`[data-ship-pref][value="${focus}"]`, container)?.focus({ preventScroll: true });
      return;
    }
    if (!designPreview || !container) return;
    const { asap, together, mixed } = allocation;
    container.hidden = !allocation.valid || !mixed;
    if (!allocation.valid) { container.replaceChildren(); return; }
    const totals = (plan) => `<span class="dopt__money"><strong>${escape(money(plan.merch))}</strong><small>Merchandise · shipping at checkout</small></span>`;
    if (!mixed) {
      container.replaceChildren();
      return;
    }
    const save = asap.merch - together.merch;
    const card = (value, title, sub, plan) => `<label class="dopt ${shipPreference === value ? 'is-on' : ''}"><input type="radio" name="polygons-ship-pref" value="${value}" data-ship-pref ${shipPreference === value ? 'checked' : ''}><span class="dopt__main"><strong>${escape(title)}</strong><small>${sub}</small></span>${totals(plan)}</label>`;
    container.innerHTML = `<fieldset class="dopts"><legend class="opt__label">Delivery</legend>${card('asap', 'Ship available items now', `Backordered items ship ${escape(restockLabel)}. Shipping charged for each shipment.`, asap)}${card('together', 'Send everything together', `All items ship ${escape(restockLabel)}. <b>${escape(combinedBenefit(save, money))}</b>`, together)}</fieldset>`;
  };
  const render = () => {
    active = Math.max(0, Math.min(active, slots.length - 1));
    const variant = activeVariant();
    const previewIndex = previewColor ?? slots[active];
    const groups = selection();
    const allocation = designPreview ? plans() : testProduct ? liveAllocation() : null;
    const valid = designPreview || testProduct ? allocation.valid : canOrder(groups);
    const anyBackorder = designPreview ? allocation.ships.includes(1) : testProduct ? allocation.counts.backorder > 0 : groups.some((item) => isBackorder(item.variant));
    const distinctColors = new Set(slots).size;
    $('[data-price]').textContent = money(variant.price);
    $$('[data-tier-price]').forEach((element) => {
      const pack = element.closest('[data-pack]');
      const tier = previewTier(Number(pack.dataset.pack));
      element.firstChild.textContent = money(designPreview ? Math.round(variant.price * (100 - tier.now) / 100) : variant.price);
      if (designPreview) {
        if (!$('.tier__off', pack)) pack.insertAdjacentHTML('beforeend', '<span class="tier__off"></span><span class="tier__back"></span>');
        $('.tier__off', pack).textContent = tier.now ? `−${tier.now}%` : 'List price';
        $('.tier__back', pack).textContent = `${money(Math.round(variant.price * (100 - tier.back) / 100))} backorder`;
      }
    });
    if (designPreview && !$('.price-alt', $('[data-price-area]'))) $('[data-price-area]').insertAdjacentHTML('beforeend', '<span class="price-alt">Bundle &amp; save up to 10% · 20% on backorder</span>');
    $$('[data-pack]').forEach((button) => {
      const on = Number(button.dataset.pack) === slots.length;
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-checked', String(on));
      button.tabIndex = on || (slots.length > 5 && button.dataset.pack === '5') ? 0 : -1;
    });
    $$('[data-color]').forEach((button) => {
      const index = Number(button.dataset.color);
      const on = index === previewIndex;
      button.setAttribute('aria-checked', String(on));
      button.tabIndex = on ? 0 : -1;
      button.dataset.state = stateOf(variants[index]);
      button.setAttribute('aria-label', `${variants[index].title}: ${availability(variants[index])}`);
      button.title = `${variants[index].title}: ${availability(variants[index])}`;
      if (designPreview && /^(pink|yellow|purple)$/i.test(variants[index].title) && !$('.swatch__new', button)) button.insertAdjacentHTML('beforeend', '<span class="swatch__new" aria-hidden="true">New</span>');
    });
    renderSlots(allocation);
    const state = testProduct ? !valid ? 'waitlist' : anyBackorder ? 'backorder' : 'in-stock' : stateOf(variant);
    let statusTitle = text(state === 'waitlist' ? 'soldOut' : state.startsWith('backorder') ? 'backorder' : 'available');
    let statusSub = state.startsWith('backorder') ? data.backorderMessage || text('backorderSub') : '';
    if (testProduct) {
      statusTitle = valid ? testText('allocation_summary', allocation.counts) : testText('invalid_selection');
      statusSub = testText('inventory_note');
    }
    if (designPreview) {
      const copy = {
        'in-stock': ['In stock, ready to ship', 'Ships in 3-5 business days'],
        low: [`Only ${variant.stock} sets left in ${variant.title}`, 'Ships in 3-5 business days'],
        backorder: [`${variant.title} ships ${restockLabel}`, 'Sold out now. Backorder at the lower backorder price.'],
        'backorder-low': [`Only ${variant.previewBack} sets left in the ${restockLabel} restock`, `${variant.title} is sold out now. After these, join the waitlist.`],
        waitlist: [`${variant.title} is sold out`, 'Choose another color to add your sets.'],
      }[state];
      [statusTitle, statusSub] = copy;
      if (anyBackorder) {
        const ready = allocation.ships.filter(pool => pool === 0).length;
        const deferred = allocation.ships.filter(pool => pool === 1).length;
        statusTitle = ready ? ready + ' ready · ' + deferred + ' on backorder' : deferred + ' sets on backorder';
        statusSub = 'Backorders ship ' + restockLabel;
      }
    }
    $('[data-status]').hidden = valid;
    $('[data-status]').textContent = valid ? '' : statusTitle;
    if ($('[data-backorder-message]')) $('[data-backorder-message]').hidden = !anyBackorder;
    renderDelivery(allocation);
    variantInput.value = String(variant.id);
    quantityInput.value = groups.length === 1 ? String(groups[0].quantity) : '1';
    giftNote.hidden = !giftToggle.checked;
    giftNote.disabled = !giftToggle.checked;
    $('[data-backorder-property]').disabled = !anyBackorder;
    $('[data-native-payment]').hidden = testProduct || !designPreview && (groups.length !== 1 || !valid || busy);
    $('[data-native-payment]').inert = designPreview || testProduct;
    $('[data-buy-now]').hidden = testProduct || designPreview || groups.length === 1;
    $('[data-buy-now]').disabled = !valid || busy;
    $('[data-add]').disabled = !valid || busy;
    const addLabel = !valid ? text(groups.every((item) => item.variant.available) ? 'quantityUnavailable' : 'soldOut') : busy ? text('loading') : `${text(!designPreview && anyBackorder ? 'backorderAction' : 'add')} ${slots.length} ${text(slots.length === 1 ? 'set' : 'sets')}  |  ${money(total())}`;
    $('[data-add-label]').textContent = addLabel;
    if ($('[data-add-subtitle]')) $('[data-add-subtitle]').textContent = testProduct ? testText('add_note') : valid ? text('shippingCheckout') : '';
    $('[data-sticky-cta]').textContent = addLabel;
    $('[data-sticky-cta]').disabled = !valid || busy;
    $('[data-sticky-meta]').textContent = groups.length > 1 ? `${slots.length} ${text('sets')}` : `${variant.title} · ${slots.length} ${text(slots.length === 1 ? 'set' : 'sets')}`;
    showImage(variants[previewIndex]);
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    if (designPreview) {
      if (slots.length > 1) url.searchParams.set('colors', slots.map((index) => variants[index].title.toLowerCase()).join(','));
      else url.searchParams.delete('colors');
      if (allocation.mixed) url.searchParams.set('ship', shipPreference);
      else url.searchParams.delete('ship');
    }
    history.replaceState({}, '', url);
  };
  const resizePack = (number, distinct = false) => {
    const next = Math.min(99, Math.max(1, number));
    const color = slots[active];
    const defaults = distinct ? defaultPackSlots(next, variants, color) : [];
    if (distinct && !defaults.length) { setError('[data-purchase-error]', 'No colors are in stock. Choose backorder colors individually.'); return; }
    slots = distinct ? defaults : Array.from({ length: next }, (_, index) => slots[index] ?? color);
    previewColor = null;
    active = Math.min(active, next - 1);
    render();
  };
  document.addEventListener('click', (event) => {
    if (busy) return;
    const color = event.target.closest('[data-color]');
    if (color) { previewColor = Number(color.dataset.color); slots = mainColorSlots(slots, previewColor); render(); return; }
    const pack = event.target.closest('[data-pack]');
    if (pack) { resizePack(Number(pack.dataset.pack), true); return; }
    const slot = event.target.closest('[data-slot]');
    if (slot) { active = Number(slot.dataset.slot); previewColor = null; render(); return; }
    const remove = event.target.closest('[data-slot-remove]');
    if (remove && slots.length > 1) { slots.splice(Number(remove.dataset.slotRemove), 1); active = Math.min(active, slots.length - 1); previewColor = null; render(); return; }
    if (event.target.closest('[data-slot-add]')) { resizePack(slots.length + 1); active = slots.length - 1; render(); return; }
    if (event.target.closest('[data-slot-all]')) { slots = slots.map(() => slots[active]); render(); }
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-set-color]');
    if (select && !busy) {
      const index = Number(select.value);
      const position = Number(select.dataset.setColor);
      if (Number.isInteger(index) && variants[index] && position >= 0 && position < slots.length) { slots[position] = index; active = position; previewColor = null; render(); }
      return;
    }
    if ((designPreview || testProduct) && event.target.matches('[data-ship-pref]') && !busy) { shipPreference = event.target.value === 'asap' ? 'asap' : 'together'; render(); }
  });
  document.addEventListener('keydown', (event) => {
    const button = event.target.closest('[data-color],[data-pack]');
    if (!button || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key) || busy) return;
    event.preventDefault();
    const type = button.hasAttribute('data-color') ? 'color' : 'pack';
    const group = button.closest('[role="radiogroup"]');
    const buttons = $$(`[data-${type}]`, group);
    const index = (buttons.indexOf(button) + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length;
    buttons[index].click();
    buttons[index].focus();
  });
  variantInput.addEventListener('change', () => { const index = variants.findIndex((variant) => String(variant.id) === variantInput.value); if (index >= 0) { slots = slots.map(() => index); render(); } });
  const request = async (endpoint, body) => {
    if (designPreview && body !== undefined) throw new Error('Design preview: Shopify cart changes and checkout are disabled.');
    const response = await fetch(root + endpoint, { method: body === undefined ? 'GET' : 'POST', headers: { 'Accept': 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) }, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
    const value = await response.json();
    if (!response.ok) {
      const error = new Error(typeof value.description === 'string' ? value.description : typeof value.message === 'string' ? value.message : text('error'));
      error.status = response.status;
      throw error;
    }
    return value;
  };
  const refreshTestInventory = async () => {
    const url = new URL(data.productUrl, location.origin);
    url.searchParams.set('section_id', data.sectionId);
    url.searchParams.set('preview_theme_id', data.themeId);
    const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(testText('refresh_failed'));
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = JSON.parse(html.getElementById('PolygonsData')?.textContent || 'null');
    if (!fresh?.testProduct || String(fresh.productId) !== String(data.productId) || !Array.isArray(fresh.variants)) throw new Error(testText('refresh_failed'));
    for (const variant of variants) {
      const updated = fresh.variants.find((item) => String(item.id) === String(variant.id));
      if (!updated || !Number.isFinite(updated.stock) || !Number.isFinite(updated.price)) throw new Error(testText('refresh_failed'));
      Object.assign(variant, updated);
    }
  };
  const allocationFingerprint = (allocation) => JSON.stringify(allocation.units.map(({ id, pool, variant }) => [String(id), pool, variant.price]));
  const testNotice = () => {
    setError('[data-cart-error]', testText('checkout_pending'));
    ui()?.toast(testText('checkout_pending'));
  };
  const previewNotice = () => {
    const message = 'Team preview · Checkout disabled. Your Shopify cart has not changed.';
    setError('[data-cart-error]', message);
    ui()?.toast(message);
  };
  const renderPreviewCart = () => {
    const allocation = previewTotals(previewCartSlots, variants, shippingEstimate);
    const plan = allocation[previewCartPreference];
    const groups = groupSelection(previewCartSlots, variants);
    const previewTotal = plan.merch;
    const dispatchFor = id => {
      const counts = previewGroupDispatch(id, previewCartSlots, variants, allocation);
      if (allocation.mixed && previewCartPreference === 'together') return 'Ships ' + restockLabel;
      if (counts.ready && counts.backorder) return counts.ready + ' ship now · ' + counts.backorder + ' ships ' + restockLabel;
      return counts.backorder ? 'Ships ' + restockLabel : 'Ships now';
    };
    $$('[data-cart-count]').forEach((element) => { element.textContent = previewCartSlots.length; });
    $('[data-cart-fallback]').hidden = true;
    $('[data-total]').textContent = money(previewTotal);
    $('[data-ship]').textContent = 'Shipping is calculated after your address is entered.';
    $('[data-summary]').innerHTML = `<div class="sum"><div class="sum__row"><span>Merchandise</span><span>${escape(money(previewTotal))}</span></div><div class="sum__row"><span>Shipping</span><span>Calculated at checkout</span></div></div>`;
    $('[data-lines]').innerHTML = groups.length ? groups.map(({ variant, quantity }) => `<article class="line-item"><img class="line-item__img" src="${escape(variant.thumb)}" alt="${escape(variant.title)}" width="76" height="76"><div><p class="line-item__title">${escape(data.title)}</p><p class="line-item__meta">${escape(variant.title)} · ${quantity} ${quantity === 1 ? 'set' : 'sets'}</p><p class="line-item__meta">${escape(dispatchFor(variant.id))}</p></div><button type="button" class="line-item__remove" data-preview-remove="${escape(variant.id)}">${escape(text('remove'))}</button></article>`).join('') : `<div class="drawer__empty"><p>${escape(text('emptyCart'))}</p><button class="btn btn--ghost" type="button" data-close>${escape(text('continueShopping'))}</button></div>`;
    $('[data-checkout]').disabled = true;
    $('[data-checkout]').setAttribute('aria-disabled', 'true');
    $('[data-checkout]').textContent = 'Checkout disabled for this team preview';
    setError('[data-cart-error]', '');
    document.dispatchEvent(new CustomEvent('polygons:cart-state', { detail: { mode: 'preview', handles: previewCartSlots.length ? ['spoon'] : [] } }));
  };
  const renderCart = () => {
    if (designPreview) { renderPreviewCart(); return; }
    if (!cart) return;
    $('[data-cart-fallback]').hidden = true;
    currency = cart.currency || currency;
    $$('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
    $('[data-total]').textContent = money(cart.total_price);
    $('[data-ship]').textContent = text('shippingCheckout');
    $('[data-lines]').innerHTML = cart.items.length ? cart.items.map((item) => {
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && !['Gift', 'Gift note'].includes(key) && value);
      const discounts = (item.line_level_discount_allocations || []).map((discount) => `<p class="line-item__meta">${escape(discount.discount_application.title)} −${escape(money(discount.amount))}</p>`).join('');
      return `<article class="line-item"><a href="${escape(item.url)}">${item.image ? `<img class="line-item__img" src="${escape(item.image)}" alt="${escape(item.product_title)}" width="76" height="76">` : ''}</a><div><a class="line-item__title" href="${escape(item.url)}">${escape(item.product_title)}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="line-item__meta">${escape(item.variant_title)}</p>` : ''}${properties.map(([key, value]) => `<p class="line-item__meta">${escape(key)}: ${escape(value)}</p>`).join('')}${discounts}<div class="qty"><button type="button" data-cart-key="${escape(item.key)}" data-delta="-1" aria-label="${escape(text('decrease'))}" ${busy ? 'disabled' : ''}>${icon('minus')}</button><span>${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-delta="1" aria-label="${escape(text('increase'))}" ${busy ? 'disabled' : ''}>${icon('plus')}</button></div></div><div class="line-item__right"><div><p class="line-item__price">${escape(money(item.final_line_price))}</p>${item.original_line_price > item.final_line_price ? `<p class="line-item__compare">${escape(money(item.original_line_price))}</p>` : ''}</div><button type="button" class="line-item__remove" data-cart-remove="${escape(item.key)}" ${busy ? 'disabled' : ''}>${escape(text('remove'))}</button></div></article>`;
    }).join('') : `<div class="drawer__empty"><p>${escape(text('emptyCart'))}</p><button class="btn btn--ghost" type="button" data-close>${escape(text('continueShopping'))}</button></div>`;
    const discounts = (cart.cart_level_discount_applications || []).map((discount) => `<div class="sum__row sum__row--save"><span>${escape(discount.title)}</span><span>−${escape(money(discount.total_allocated_amount))}</span></div>`).join('');
    $('[data-summary]').innerHTML = discounts ? `<div class="sum">${discounts}</div>` : '';
    $('[data-checkout]').disabled = busy || !cart.item_count;
    $('[data-checkout]').setAttribute('aria-disabled', String(busy || !cart.item_count));
    if (testProduct) {
      $('[data-checkout]').disabled = true;
      $('[data-checkout]').setAttribute('aria-disabled', 'true');
      $('[data-checkout]').textContent = testText('checkout_label');
      if (cart.items.some((item) => String(item.product_id) === String(data.productId))) {
        $('[data-summary]').insertAdjacentHTML('beforeend', `<p class="polygons-test-cart-note">${escape(testText('checkout_pending'))}</p>`);
        $$('[data-cart-key]').forEach((button) => {
          const item = cart.items.find((line) => line.key === button.dataset.cartKey);
          if (String(item?.product_id) === String(data.productId)) button.disabled = true;
        });
      }
    }
  };
  const readCart = () => {
    if (designPreview) { renderPreviewCart(); return Promise.resolve(null); }
    if (cartRead) return cartRead;
    cartRead = request('cart.js').then((value) => { cart = value; renderCart(); if (testProduct) render(); return value; }).finally(() => { cartRead = null; });
    return cartRead;
  };
  const mutate = async (operation, selector) => {
    if (busy) return false;
    busy = true;
    let committed = false;
    setError(selector, '');
    render(); renderCart();
    try {
      if (cartRead) await cartRead.catch(() => {});
      await operation();
      committed = true;
      if (cartRead) await cartRead.catch(() => {});
      await readCart();
      return true;
    } catch (error) {
      const message = committed ? text('cartRefreshError') : error.status || error.review ? error.message : text('cartConfirmError');
      setError(selector, message);
      ui()?.toast(message);
      try { await readCart(); } catch {
        cart = null;
        $('[data-lines]').replaceChildren();
        $('[data-cart-fallback]').hidden = false;
        $('[data-checkout]').disabled = true;
        setError('[data-cart-error]', message);
      }
      return committed;
    } finally { busy = false; render(); renderCart(); }
  };
  const addSelection = async (checkout = false) => {
    const groups = selection();
    if (designPreview) {
      if (!plans().valid || busy) return;
      if (previewCartSlots.length + slots.length > 99) { setError('[data-purchase-error]', 'Please review the quantities in your cart.'); ui()?.open('cart'); return; }
      previewCartSlots = [...previewCartSlots, ...slots];
      previewCartPreference = shipPreference;
      previewGift = giftToggle.checked ? giftNote.value.trim() || 'Gift (no note)' : '';
      renderPreviewCart();
      ui()?.open('cart');
      previewNotice();
      return;
    }
    if (!canOrder(groups) || busy) return;
    if (testProduct) {
      const allocation = liveAllocation();
      if (!allocation.valid) return;
      const fingerprint = allocationFingerprint(allocation);
      const success = await mutate(async () => {
        await readCart();
        await refreshTestInventory();
        const refreshed = liveAllocation();
        if (!refreshed.valid || allocationFingerprint(refreshed) !== fingerprint) {
          const error = new Error(testText('allocation_changed'));
          error.review = true;
          throw error;
        }
        const items = allocationModel.buildItems(refreshed, deliveryChoice(), { enabled: giftToggle.checked, note: giftNote.value.trim() });
        await request('cart/add.js', { items });
      }, '[data-purchase-error]');
      if (success) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })); ui()?.open('cart'); ui()?.toast(text('added')); }
      return;
    }
    const items = groups.map(({ variant, id, quantity }) => {
      const properties = {};
      if (giftToggle.checked) { properties.Gift = 'Yes'; if (giftNote.value.trim()) properties['Gift note'] = giftNote.value.trim(); }
      if (isBackorder(variant)) properties['Order type'] = 'Backorder';
      return { id, quantity, ...(Object.keys(properties).length ? { properties } : {}) };
    });
    const success = await mutate(() => request('cart/add.js', { items }), '[data-purchase-error]');
    if (!success) return;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    if (checkout) location.assign(root + 'checkout');
    else { ui()?.open('cart'); ui()?.toast(text('added')); }
  };
  form.addEventListener('submit', (event) => { event.preventDefault(); addSelection(); });
  $('[data-buy-now]').addEventListener('click', () => addSelection(true));
  $('[data-sticky-cta]').addEventListener('click', () => addSelection());
  document.addEventListener('click', async (event) => {
    const previewRemove = event.target.closest(commerceSelector('[data-preview-remove]'));
    if (designPreview && previewRemove) {
      previewCartSlots = previewCartSlots.filter((index) => String(variants[index].id) !== previewRemove.dataset.previewRemove);
      renderPreviewCart();
      return;
    }
    const remove = event.target.closest(commerceSelector('[data-cart-remove]'));
    const step = event.target.closest(commerceSelector('[data-cart-key]'));
    if (remove || step) {
      if (!cart || busy) return;
      const key = remove?.dataset.cartRemove || step.dataset.cartKey;
      const item = cart.items.find((line) => line.key === key);
      if (!item) return;
      if (testProduct && step && String(item.product_id) === String(data.productId)) return;
      const quantity = remove ? 0 : Math.max(0, item.quantity + Number(step.dataset.delta));
      await mutate(() => request('cart/change.js', { id: key, quantity }), '[data-cart-error]');
      return;
    }
    const quick = event.target.closest('[data-quick-add]');
    if (quick && !busy) {
      if (designPreview) { ui()?.open('cart'); previewNotice(); return; }
      const success = await mutate(() => request('cart/add.js', { items: [{ id: Number(quick.dataset.quickAdd), quantity: 1 }] }), '[data-cart-error]');
      if (success) { ui()?.open('cart'); ui()?.toast(text('added')); }
    }
  });
  if (designPreview || testProduct) {
    // Stop native cart forms, accelerated checkout and linked checkout routes before their handlers run.
    document.addEventListener('submit', (event) => {
      if (event.target === form) return;
      const action = event.target.getAttribute('action') || '';
      if (/\/(?:cart|checkout)(?:[/.?]|$)/i.test(action) || event.submitter?.name === 'checkout') {
        event.preventDefault(); event.stopImmediatePropagation(); ui()?.open('cart'); if (testProduct) testNotice(); else previewNotice();
      }
    }, true);
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href],[data-checkout],[data-quick-add],[data-preview-pay],.shopify-payment-button');
      if (!trigger) return;
      const href = trigger.getAttribute('href') || '';
      if (!trigger.matches('a') || /\/(?:cart|checkout|checkouts)(?:[/.?]|$)/i.test(href)) {
        event.preventDefault(); event.stopImmediatePropagation(); if (testProduct) { renderCart(); testNotice(); } else { renderPreviewCart(); previewNotice(); } ui()?.open('cart');
      }
    }, true);
  }
  document.addEventListener('polygons:cart-state-request', () => { if (designPreview) renderPreviewCart(); });
  document.addEventListener('polygons:preview-upsell-choose', event => {
    if (!designPreview || event.detail?.handle !== 'spoon') return;
    ui()?.close(); $('.buy__colors')?.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'center' }); $('[data-color]')?.focus({ preventScroll: true });
  });
  const showCartReadError = () => { $('[data-cart-fallback]').hidden = false; setError('[data-cart-error]', text('cartConfirmError')); };
  document.addEventListener('polygons:sheet-open', (event) => { if (event.target.dataset.sheet === 'cart') readCart().catch(showCartReadError); });
  $('[data-checkout]').closest('form')?.addEventListener('submit', (event) => { if (testProduct || busy || !cart?.item_count) event.preventDefault(); });
  const sticky = $('[data-sticky]');
  const syncSticky = () => {
    const show = $('[data-main-cta]').getBoundingClientRect().bottom < 0 && $('.site-footer').getBoundingClientRect().top > innerHeight;
    sticky.classList.toggle('is-visible', show);
    sticky.inert = !show;
    sticky.setAttribute('aria-hidden', String(!show));
    $('[data-sticky-cta]').tabIndex = show ? 0 : -1;
    document.body.classList.toggle('sticky-visible', show);
  };
  let stickyFrame;
  addEventListener('scroll', () => { cancelAnimationFrame(stickyFrame); stickyFrame = requestAnimationFrame(syncSticky); }, { passive: true });
  addEventListener('resize', () => { goTo(slide); syncSticky(); });
  document.documentElement.classList.add('polygons-ready');
  giftNote.disabled = !giftToggle.checked;
  render(); syncGallery(); syncSticky();
  readCart().catch(showCartReadError);
})();
